/**
 * Return true if array is undefined, null, or of length zero.
 * @param arr array to be tested.
 */
export var isArrayEmptyOrNull = function isArrayEmptyOrNull(arr) {
  return !arr || arr.length == 0;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/dropin-payments/dist/esm/utils/ObjectUtils.js
// module id = 665
// module chunks = 11